module.exports = __webpack_public_path__ + "static/media/antonio_cosio.e1169da1.png";